import MenuItem from "@mui/material/MenuItem";
import { IconButton } from "@mui/material";
import { useState } from "react";
import { MoreVertIcon } from "../../../images/MoreVertIcon";
import { StyledMenu } from "../../StyledMenu";

type Props = {
  isDisabled: boolean;
  removeUserHandler: () => void;
};
export const SharedUserMenu = ({ isDisabled, removeUserHandler }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        disabled={isDisabled}
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        style={{ borderRadius: "8px" }}
      >
        <MoreVertIcon width="24" />
      </IconButton>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "white",
          },
        }}
      >
        <MenuItem
          sx={{ display: "flex", gap: "12px", alignItems: "center" }}
          onClick={removeUserHandler}
        >
          Remove
        </MenuItem>
      </StyledMenu>
    </div>
  );
};
